import React, { useEffect } from "react";
import styled from "styled-components";
import { useAtom, useAtomValue } from "jotai";
import { soundPopState } from "@stores/popup";
import playSound from "@/sound";
import SoundPlayerBar from "@components/modules/SoundPlayerBar";
import PopupCloseButton from "@components/elements/PopupCloseButton";
import { currentPageState } from "@stores/vars";

const Wrap = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #00ba95;
  z-index: 105;
  animation: fullDown 0.4s cubic-bezier(0.16, 1, 0.3, 1);
`;

const ImageCover = styled.div`
  width: 376px;
  height: 376px;
  background-color: #fff;
  border-radius: 30px;
  background: url(${({ url }) => url});
  background-size: 100%;
  box-shadow: 4px 4px 0px 1px rgba(0, 0, 0, 0.13);
`;

const PlayerWrap = styled.div`
  margin-top: 100px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  .column {
    flex: 0 auto;
    &:first-child {
      margin-right: 40px;
    }
  }
`;

const Title = styled.div`
  font-size: 50px;
  color: #fff;
`;
const SubTitle = styled.div`
  margin: 20px 0;
  font-size: 80px;
  color: #fff;
  font-family: Noto Sans SC;
`;

const CaptionWrap = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 1700px;
  padding: 70px 35px;
  margin: 35px auto 0;
  height: 615px;
  border-radius: 80px;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba(255, 255, 255, 0.6);
`;

const Inner = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  text-align: center;
  font-family: Noto Sans SC;
  &::-webkit-scrollbar {
    width: 34px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ffba00;
    border-radius: 20px;
  }
  &::-webkit-scrollbar-track {
    background-color: #000;
    border-radius: 20px;
  }
`;

const LineTextWrap = styled.div`
  margin-bottom: 42px;
  color: #0e7644;
  &:first-child {
    margin-top: 35px;
  }
  &:last-child {
    margin-bottom: 65px;
  }
`;

const TextKr = styled.div`
  font-size: 50px;
  font-weight: bold;
  color: #0e7644;
`;

const SoundAndRead = () => {
  const [info, showSoundPlayPopup] = useAtom(soundPopState);
  const currentPage = useAtomValue(currentPageState);

  useEffect(() => {
    document.body.classList.add("has-popup");
    playSound.bgm(null);
    return () => {
      if (currentPage === "main") {
        playSound.bgm(require("@assets/sounds/bgm/main.mp3"));
      } else if (currentPage === "book") {
        playSound.bgm(require("@assets/sounds/bgm/book.mp3"));
      }

      document.body.classList.remove("has-popup");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Wrap>
      <PlayerWrap>
        <div className="column">
          <ImageCover url={info.cover} />
        </div>
        <div className="column">
          <Title>{`${info.category} ${info.grade} - ${info.title}`}</Title>
          <SubTitle>{info.songTitle}</SubTitle>
          <SoundPlayerBar url={info.url} />
        </div>
      </PlayerWrap>
      <CaptionWrap>
        <Inner>
          {info.caption.map((data, i) => {
            return (
              <LineTextWrap key={i}>
                <TextKr>
                  <div dangerouslySetInnerHTML={{ __html: data }}></div>
                </TextKr>
              </LineTextWrap>
            );
          })}
        </Inner>
      </CaptionWrap>
      <PopupCloseButton
        onClick={() => {
          showSoundPlayPopup(false);
        }}
      />
    </Wrap>
  );
};

export default React.memo(SoundAndRead);
